/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Icon } from "@aws-amplify/ui-react";
export default function Errorfailedlarge(props) {
  const { overrides, ...rest } = props;
  return (
    <Icon
      width="128px"
      height="128px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 128, height: 128 }}
      paths={[
        {
          d: "M95.25 48C95.25 74.0955 74.0955 95.25 48 95.25L48 96.75C74.9239 96.75 96.75 74.9239 96.75 48L95.25 48ZM48 95.25C21.9045 95.25 0.75 74.0955 0.75 48L-0.75 48C-0.75 74.9239 21.0761 96.75 48 96.75L48 95.25ZM0.75 48C0.75 21.9045 21.9045 0.75 48 0.75L48 -0.75C21.0761 -0.75 -0.75 21.0761 -0.75 48L0.75 48ZM48 0.75C74.0955 0.75 95.25 21.9045 95.25 48L96.75 48C96.75 21.0761 74.9239 -0.75 48 -0.75L48 0.75Z",
          stroke: "rgba(246,182,196,1)",
          fillRule: "nonzero",
          strokeLinejoin: "round",
          strokeWidth: 1,
          style: { transform: "translate(12.5%, 12.5%)" },
        },
        {
          d: "M0.53033 -0.53033C0.237437 -0.823223 -0.237437 -0.823223 -0.53033 -0.53033C-0.823223 -0.237437 -0.823223 0.237437 -0.53033 0.53033L0.53033 -0.53033ZM20.803 21.8637C21.0959 22.1566 21.5708 22.1566 21.8637 21.8637C22.1566 21.5708 22.1566 21.0959 21.8637 20.803L20.803 21.8637ZM21.8637 0.53033C22.1566 0.237437 22.1566 -0.237437 21.8637 -0.53033C21.5708 -0.823223 21.0959 -0.823223 20.803 -0.53033L21.8637 0.53033ZM-0.53033 20.803C-0.823223 21.0959 -0.823223 21.5708 -0.53033 21.8637C-0.237437 22.1566 0.237437 22.1566 0.53033 21.8637L-0.53033 20.803ZM-0.53033 0.53033L20.803 21.8637L21.8637 20.803L0.53033 -0.53033L-0.53033 0.53033ZM20.803 -0.53033L-0.53033 20.803L0.53033 21.8637L21.8637 0.53033L20.803 -0.53033Z",
          stroke: "rgba(246,182,196,1)",
          fillRule: "nonzero",
          strokeLinejoin: "round",
          strokeWidth: 1,
          style: { transform: "translate(41.67%, 41.67%)" },
        },
      ]}
      {...getOverrideProps(overrides, "Errorfailedlarge")}
      {...rest}
    ></Icon>
  );
}
